<div class="main">
  <div #scrollBox class="container">
    @if (messages.length === 0) {
      <div class="welcome-message">
        <h1>How can I help you today?</h1>
      </div>
    }
    
    <div class="messages-container">
      <div  class="messages">
        @for(message of messages; track $index) {
          @if (message.role == 'user') {
            <div class="message user">
              <div class="message-content">{{ message?.content }}</div>
            </div>
            
          }
          @if (message.role == 'assistant') {
            <div class="message assistant">
              <div class="message-content">
                <app-message-renderer
                  [components]="message.content"
                  [disabled]="loading"
                  (promptSend)="onStreamSend($event, false)"
                ></app-message-renderer>
              </div>
            </div>
          }
  
          @if (message.role == 'error') {
            <div class="message error">
              <div class="message-content"><mat-icon>warning</mat-icon> {{ message?.content }}</div>
            </div>
          }
        }
  
        @if(streamBubbleVisible) {
          <div class="message assistant stream-bubble">
            <div class="message-content stream-bubble-content">
              <span class="stream-progress" aria-hidden="true"></span>
              <span class="stream-message">{{ streamBubbleMessage }}</span>
            </div>
          </div>
        }
  
      </div>
  
    </div>
    <div class="chat-container">
      <app-chat-input
        (messageSend)="onStreamSend($event)"
        [disabled]="loading"
        style="width: 100%">
      </app-chat-input>
    </div>
  </div>
</div>